module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 67
// module chunks = 39